import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);

  const token = sessionStorage.getItem('token');
  const apiBase = String(environment.apiUrl || '').replace(/\/+$/, '');
  const isApiRequest = Boolean(apiBase) && req.url.startsWith(apiBase);

  let authReq = req;

  if (token && isApiRequest && !req.url.includes('/login')) {

    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }


  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {

      if (isApiRequest && error.status === 401) {

        sessionStorage.clear();

        router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};